
import { Vue, Component, Prop } from "vue-property-decorator";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import GET_MANAGERS_ACCESSED_TO_CONTRACTOR from "@/apollo/managers/GetManagersAccessedContractor.gql";
import ManagerListCard from "@/components/managers/ManagerCardResources.vue";
import ManagerSimpleCard from "@/components/managers/ManagerSimpleCard.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import AddContractorToManager from "@/components/managers/AddContractorToManagerNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import RouteNames from "@/entities/RouteNames";
import PaginationConfig from "@/entities/PaginationConfig";
import { Manager } from "@/generated/graphql";
import paginationConfig from "@/data/paginationConfig";
import { Manager_Contractor_Bool_Exp, User_Profile } from "@/generated/graphql";
import { NO_INFORMATION } from "@/data/placeholders";
import UiButton from "@/components/button/ui-button.vue";
import { User } from "@/generated/graphql";
import EmptyListImageManagers from "@/components/icons/emptyListImages/EmptyListImageManagers.vue";

interface ManagerArgs {
  limit: number;
  offset: number;
  where: Manager_Contractor_Bool_Exp;
}
@Component({
  components: {
    EmptyListImageManagers,
    ManagerListCard,
    AddContractorToManager,
    ManagerSimpleCard,
    LoadingOverlay,
    UiButton,
    CardBodyItem,
    CardPagination,
    EmptyListPlaceholder,
  },
  apollo: {
    managers: {
      query: GET_MANAGERS_ACCESSED_TO_CONTRACTOR,
      variables() {
        return this.managersArgs;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.manager_contractor.length;
        return data.manager_contractor;
      },
    },
  },
})
export default class Managers extends Vue {
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  managers: Manager[] | undefined = undefined;

  processing: boolean = false;
  paginationConfig: PaginationConfig = { ...paginationConfig };

  get isManagersExist(): boolean {
    if (this.managers) {
      return this.managers.length > 0;
    }
    return false;
  }

  get isDataLoaded(): boolean {
    return Boolean(this.managers);
  }

  getLocation(profile: User_Profile): string {
    const { country, city } = profile;
    const location = [city, country]
      .filter((place) => Boolean(place))
      .join(" ");
    return location || NO_INFORMATION;
  }

  message(item: Manager): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: item.user.id,
      },
    });
  }

  get isLoading(): boolean {
    return this.$apollo.queries.managers.loading || this.processing;
  }

  get managersArgs(): ManagerArgs {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;

    return {
      offset: nextOffset,
      limit: limit,
      where: {
        _and: [
          {
            contractor: {
              user_id: {
                _eq: this.contractorUserId,
              },
            },
          },
          {
            approved: {
              _eq: true,
            },
          },
        ],
      },
    };
  }

  // get confirmedConditions() {
  //   if (!(this.currentUser.role === "ADMIN")) {
  //     return {
  //       confirmed: {
  //         _eq: true,
  //       },
  //     };
  //   } else {
  //     return {};
  //   }
  // }
  get emptyListSubtitle(): string {
    return `Start adding managers to ${this.contractorFullName}`;
  }

  async updateManagerList(): Promise<void> {
   await this.$apollo.queries.managers.refetch();
  }
}
